import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../i18n/LocaleContext';
import './Footer.css';  // Import the corresponding CSS for styling
import logo from '../Asset/_Path_ (13).png'
const Footer = () => {
  const { t } = useTranslation();
  const { path } = useLocale();
  return (
    <footer className="footer">
      <div className="footer-logo">
        <a href={path('/')}><img src={logo} alt="Logo" className="logo"/></a>
      </div>
      <div className="footer-right">
        <div className="footer-section">
          <h4>{t('footer.contact')}</h4>
          <ul>
            <li><strong>{t('footer.emailLabel')}</strong> <span dir="ltr" className="ltr-inline">info@SoftUp.agency</span></li>
            <li><strong>{t('footer.phoneLabel')} </strong><span dir="ltr" className="ltr-inline">+1 (929) 322-8385</span></li>
            <li><strong>{t('footer.addressLabel')} </strong><span dir="ltr" className="ltr-inline">A201 E Center St <br></br> Anaheim, CA, US</span></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>{t('footer.importantLinks')}</h4>
          <ul>
            <li><script type="text/javascript" src="https://widget.clutch.co/static/js/widget.js"></script> <div class="clutch-widget" data-url="https://widget.clutch.co" data-widget-type="13" data-height="50" data-nofollow="true" data-expandifr="true" data-scale="100" data-clutchcompany-id="2456469"></div></li>
            <li><a href="#">{t('footer.termsOfService')}</a></li>
            <li><a href="#">{t('footer.aboutUs')}</a></li>
            <li><a href="#">FAQ</a></li>
            <li>      <a href="//www.dmca.com/Protection/Status.aspx?ID=21135b30-c361-4b3e-851d-069118e81ebd" title="DMCA.com Protection Status" class="dmca-badge"> <img src ="https://images.dmca.com/Badges/dmca-badge-w100-2x1-01.png?ID=21135b30-c361-4b3e-851d-069118e81ebd"  alt="DMCA.com Protection Status" /></a>  <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"> </script>            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
